export const dataMessage = `Which of the following best describes your enterprise's data characteristics?`;

const dataQ1 = `Inconsistent, poor quality, and unstandardized data; difficult to do substantial analysis; no 
                       groups with strong data orientation; basic reporting tools and descriptive analytics.`;

const dataQ2 = `Standardized and structured data, mostly in functional or process silos; senior
                       executives don’t discuss data management; BI and basic analytics tools.`;

const dataQ3 = `Key data domains identified and central data repositories created; expansion into
                       unstructured NoSQL data`;

const dataQ4 = `Integrated, accurate, common data in central repositories; data still mainly an IT
                       matter; little unique data: use of unstructured NoSQL data analysis.`;

const dataQ5 = `Relentless search for new data and metrics leveraging structured and unstructured data; 
                       organization separate from IT oversees information; data managed as strategic asset.`;

export const dataQuestions = [ dataQ1, dataQ2, dataQ3, dataQ4, dataQ5 ];
export const dataQuestionWeight = 0.20;
export const dataQuestionsScore = [ 0.20, 0.40, 0.60, 0.80, 1 ];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/data/dataQuestions.ts